import React, { Component } from "react";
import "react-widgets/dist/css/react-widgets.css";
const isEmpty = require("is-empty");


class RefactInnerBranch extends Component {
	state = {
		errorNewClave: '',
		newClave: ''
	};

	componentDidUpdate() { }

	onChangeNewClave(e) {
		this.setState({
			newClave: e.target.value,
		});
	}

	clearErrors() {
		this.setState({
			errorNewClave: null,
		});
	}

	clearData() {
		this.setState({
			errorNewClave: null,
			newClave: null
		})
	}

	async preparateSubmit() {
		await this.clearErrors()
		var old = this.props.centerData.innerBranchId;

		if (this.state.newClave == null || isEmpty(this.state.newClave))
			this.setState({ errorNewClave: "La nueva clave es requerida." });
		else
			this.setState({ isValidNewClave: true });


		if (
			this.state.isValidNewClave
		) {
			this.props.handleSubmit(
				old,
				this.state.newClave
			)

			this.setState({
				errorNewClave: null,
				newClave: null,
			});
		}
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.setState({
			errorNewClave: null,
			newClave: null,
		},
			() => {
				this.props.handleCancel();
			});
	}

	render() {
		var title = "REFACTORIZAR INNER BRANCH ID";

		return (
			<div
				className={
					this.props.isVisible ? "modal display-block" : "modal display-none"
				}
			>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						<form
							ref={(el) => {
								this.farmazonFormRef = el;
							}}
						>
							<div className="auth-label">
								Nueva Clave del centro<span className="required">*</span>
								<input
									id="newClaveForm"
									ref={(el) => {
										this.newClaveForm = el;
									}}
									onChange={this.onChangeNewClave.bind(this)}
									value={
										this.state.newClave
									}
									error={this.state.errorNewClave}
									type="title"
									placeholder={"Ej.: F015"}
									className="local-store-input"
								/>
							</div>
							<div className="auth-error">
								{this.state.errorNewClave}
							</div>
						</form>
						<div className="modal-activity-section">
							{this.props.type === "UPDATE" && (
								<button className="modal-buttonOK" onClick={this.preparateSubmit.bind(this)}>
									GUARDAR
								</button>
							)}
							{
								<button
									className="modal-buttonNo"
									onClick={this.onPressCancel.bind(this)}
								>
									CERRAR
								</button>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default RefactInnerBranch;
